// Shared verbatim between frontend and backend (scripts/verifier-parite-regles.mjs): the import
// preview and the import itself must agree on who is the same player (VOL-327, VOL-329).

/** Name as compared between players: case, accents and extra spaces do not tell them apart. */
export function comparablePlayerName(value: string | null | undefined): string {
  return (value ?? '')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

function nameTokens(value: string): string[] {
  return comparablePlayerName(value.replace(/[.,]/g, ' ')).split(' ').filter(Boolean);
}

function isInitialOf(initial: string, word: string): boolean {
  return initial.length === 1 && word.startsWith(initial);
}

/**
 * Same person written another way: words in another order (« DUPONT Léa » / « Léa Dupont »)
 * or a first name cut to its initial (« L. Dupont »). One full word at least must match, so
 * two initials alone never make a match.
 */
export function isSamePlayerName(a: string, b: string): boolean {
  const left = nameTokens(a);
  const rest = nameTokens(b);
  if (left.length === 0 || left.length !== rest.length) return false;
  let fullWords = 0;
  const unmatched: string[] = [];
  for (const word of left) {
    const i = rest.indexOf(word);
    if (i === -1) {
      unmatched.push(word);
      continue;
    }
    rest.splice(i, 1);
    if (word.length > 1) fullWords += 1;
  }
  for (const word of unmatched) {
    const i = rest.findIndex((other) => isInitialOf(word, other) || isInitialOf(other, word));
    if (i === -1) return false;
    rest.splice(i, 1);
  }
  return fullWords > 0;
}
